// apps/web/src/data.ts
//
// The ONLY module in apps/web that touches a fixture.
// Today: reads the three bundled fixtures from @oura/contract.
// The day a backend exists, ONLY this file changes — the three imports become
// one fetch, these selectors become async, and App gates once at boot.
// No screen imports a fixture. No screen knows where the snapshot came from.

import type { Business, ScoreSnapshot, LatestSnapshot } from './contract';
import { pilatesCollective } from './fixtures/pilates-collective';
import { nyonyaTable } from './fixtures/nyonya-table';
import { newClinic } from './fixtures/new-clinic';

// Registry — the one place a fixture is named. Order = business-switcher order.
const REGISTRY: LatestSnapshot[] = [pilatesCollective, nyonyaTable, newClinic];
const byId = new Map(REGISTRY.map((r) => [r.business.id, r]));

/** Businesses for the switcher and the admin table. */
export function listBusinesses(): Business[] {
  return REGISTRY.map((r) => r.business);
}

/** Business + latest snapshot for every business. Admin sorts these lowest-score-first. */
export function listSnapshots(): LatestSnapshot[] {
  return REGISTRY;
}

/** The full snapshot for one business, or null if unknown. */
export function getSnapshot(businessId: string): ScoreSnapshot | null {
  return byId.get(businessId)?.snapshot ?? null;
}

export function getBusiness(businessId: string): Business | null {
  return byId.get(businessId)?.business ?? null;
}

/** The business selected on first load. */
export const DEFAULT_BUSINESS_ID = REGISTRY[0].business.id;
